import { useEffect, useState } from 'react';

import { useViewEvent } from 'features/events/context/ViewEvent';
import SummaryStep from './components/SummaryStep';
import TicketTiersStep from './components/TicketTiers/components/steps/TicketTiersStep';
import RequestScreeningStep from './components/RequestScreeningStep';
import RequestApprovalSuccessStep from './components/RequestApprovalSuccessStep';
import { CheckoutSteps } from './types';
import CheckoutProvider from './context';
import WaiverStep from './components/WaiverStep';
import CheckoutSuccessStep from './components/CheckoutSuccessStep';
import CheckoutSkeleton from '../../../components/checkout/CheckoutSkeleton';
import { useRouter } from 'next/router';
import TicketTiersStepAddon from './components/TicketTiers/components/steps/TicketTiersStepAddon';
import PrePurchaseQuestionsStep from './components/PrePurchaseQuestionsStep';

const STEPS_MAP = {
  [CheckoutSteps.TicketTiers]: TicketTiersStep,
  [CheckoutSteps.TicketTiersAddon]: TicketTiersStepAddon,
  [CheckoutSteps.RequestScreening]: RequestScreeningStep,
  [CheckoutSteps.PrePurchaseQuestions]: PrePurchaseQuestionsStep,
  [CheckoutSteps.SuccessRequestApproval]: RequestApprovalSuccessStep,
  [CheckoutSteps.Summary]: SummaryStep,
  [CheckoutSteps.Waivers]: WaiverStep,
  [CheckoutSteps.Success]: CheckoutSuccessStep
};

const Checkout = () => {
  const [step, setStep] = useState<CheckoutSteps>(CheckoutSteps.TicketTiers);
  const { eventError, isEventLoading, event } = useViewEvent();
  const router = useRouter();

  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: 'smooth'
    });
  }, [step]);

  useEffect(() => {
    // If the event status is past, redirect to the event page
    if (event?.activeStatus === 'past') {
      router.push(`/events/${event?._id}`);
    }
  }, [event]);

  // Show the skeleton if the event is loading or the event status is past (while waiting the useEffect to redirect)
  if (isEventLoading || event?.activeStatus === 'past') {
    return <CheckoutSkeleton />;
  }

  if (eventError?.message) {
    return (
      <div className="my-20 text-center text-2xl text-gray-700">
        {eventError.message}
      </div>
    );
  }

  const StepComponent = STEPS_MAP[step];
  const goToStep = (step: CheckoutSteps) => {
    setStep(step);
  };

  return (
    <CheckoutProvider goToStep={goToStep} currentStep={step}>
      <StepComponent />
    </CheckoutProvider>
  );
};

export default Checkout;
